import { Address, RespFile } from 'modules/domain/types'
import { CompanyMembersTypes, CompanySize } from '../user/types'

export type FactoringRequest = {
  id: string
  company_id: string
  status: FactoringStatus
  document?: RespFile
  document_pdf?: RespFile
  factoring_type: FactoringTypes
}
export enum CompanyCommercial {
  yes = 'yes',
  no = 'no',
  unknown = 'unknown',
}

// factoring type mostly the same as ProfileType, but less options
export enum FactoringTypes {
  seller = 'seller',
  customer = 'customer',
}

export type Company = {
  id: string
  inn?: string
  name: string
  created: string
  payment_delay_days: number
  credit_limit: number | null
  credit_limit_comment: string | null
  debt: number | null
  remaining_signed_margin: number | null
  available_credit_limit: number | null
  prepayment?: keyof typeof Prepayment
  vat?: boolean
  state_reg_number?: string
  has_shipped_deals?: boolean
  factoring_requests?: FactoringRequest[]
  factoring_seller_status: FactoringStatus
  factoring_customer_status: FactoringStatus
  turnover_days?: number
  affectable_turnover_days?: number
  turnover_sync_date?: string
  company_size?: CompanySize | null
  company_member_types?: CompanyMembersTypes[]
  commercial: CompanyCommercial
  branch_count: number
  employees_count: number
  address?: string
  offers_count: number
  offers_count_with_branches: number
  is_significant: boolean
  companies_group_name: string
  is_in_group: boolean
  parent: {
    id: string
    name: string
    companies_group_name?: string
  } | null
  employees_count_with_branches: string
  responsible_coordinator: {
    id: string
    full_name: string
  } | null
  synced_with_accounting: boolean
  sowed_area: number | null
}

export type ResponsibleEntity = {
  id: string
  full_name: string
}

export type USCompany = {
  id: string
  name: string
  is_significant: boolean
  main_address?: Address
  responsible_coordinator: ResponsibleEntity
  inn: string
  commercial: CompanyCommercial
  responsible_seller: ResponsibleEntity
  responsible_customer: ResponsibleEntity
  is_synced_with_accounting_as_customer: boolean
  is_synced_with_accounting_as_seller: boolean
  sync_with_accounting: boolean
  parent: string | { id: string; name: string }
}

export type CompanyShort = {
  id: string
  inn: string
  name: string
  factoring_seller_status?: FactoringStatus
  factoring_customer_status?: FactoringStatus
}

export enum Prepayment {
  yes = 'yes',
  no = 'no',
  unknown = 'unknown',
}

export type CompanyAddDTO = {
  //companies_group_name: Company['companies_group_name']
  company_size: Company['company_size']
  inn: Company['inn'] | null
  name?: Company['name']
  payment_delay_days: Company['payment_delay_days']
  prepayment: Company['prepayment']
  vat: Company['vat']
  parent?: string
}

export type CompanyEditDTO = Partial<Omit<Company, 'inn' | 'parent'>> & {
  parent?: string
}

export enum ActivityType {
  processing = 'processing',
  export = 'export',
}
export enum FactoringStatus {
  not_verified = 'not_verified',
  in_progress = 'in_progress',
  cancelled = 'cancelled',
  accepted = 'accepted',
}
